import SvgIcon, { SvgIconProps } from "./SvgIcon";

const UploadIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path d="M20 17C20.5128 17 20.9355 17.386 20.9933 17.8834L21 18V20C21 21.0544 20.1841 21.9182 19.1493 21.9945L19 22H5C3.94564 22 3.08183 21.1841 3.00549 20.1493L3 20V18C3 17.4477 3.44772 17 4 17C4.51284 17 4.93551 17.386 4.99327 17.8834L5 18V20H19V18C19 17.4477 19.4477 17 20 17ZM12.6098 2.20969L12.7041 2.29289L17.7041 7.29289C18.0946 7.68342 18.0946 8.31658 17.7041 8.70711C17.3436 9.06759 16.7763 9.09532 16.384 8.7903L16.2898 8.70711L12.996 5.412L12.9969 17C12.9969 17.5523 12.5492 18 11.9969 18C11.4447 18 10.9969 17.5523 10.9969 17L10.996 5.415L7.70732 8.70689C7.34695 9.06748 6.77973 9.09539 6.38734 8.79048L6.29311 8.70732C5.93252 8.34695 5.90461 7.77973 6.20952 7.38734L6.29268 7.29311L11.2896 2.29311C11.6501 1.93244 12.2174 1.90461 12.6098 2.20969Z" />
    </SvgIcon>
  );
};

export default UploadIcon;
